import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Totes_DatasourceService } from './Totes.datasource.index';

import { ProgrammableLogicController_ds_connector_mappings_gridService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_connector_settings_ddService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_connectors_gridService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_get_connectors_name_ddService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_get_containers_ready_for_plcService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_get_orderclasses_by_idService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_get_shipping_containers_contentsService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_get_tote_groupingsService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_get_zone_by_child_location_nameService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_location_zonesService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_orderclasses_ddService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_projectName_by_idService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_projects_ddService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_ds_warehouses_ddService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_tote_checkingService } from './ProgrammableLogicController.datasource.index';

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.Totes = this.injector.get(Totes_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
    public Totes: Totes_DatasourceService;
  public ProgrammableLogicController: ProgrammableLogicController_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _ds_connector_mappings_grid: ProgrammableLogicController_ds_connector_mappings_gridService;
  public get ds_connector_mappings_grid(): ProgrammableLogicController_ds_connector_mappings_gridService {
    if(!this._ds_connector_mappings_grid) {
      this._ds_connector_mappings_grid = this.injector.get(ProgrammableLogicController_ds_connector_mappings_gridService);
    }
    return this._ds_connector_mappings_grid;
  }
  private _ds_connector_settings_dd: ProgrammableLogicController_ds_connector_settings_ddService;
  public get ds_connector_settings_dd(): ProgrammableLogicController_ds_connector_settings_ddService {
    if(!this._ds_connector_settings_dd) {
      this._ds_connector_settings_dd = this.injector.get(ProgrammableLogicController_ds_connector_settings_ddService);
    }
    return this._ds_connector_settings_dd;
  }
  private _ds_connectors_grid: ProgrammableLogicController_ds_connectors_gridService;
  public get ds_connectors_grid(): ProgrammableLogicController_ds_connectors_gridService {
    if(!this._ds_connectors_grid) {
      this._ds_connectors_grid = this.injector.get(ProgrammableLogicController_ds_connectors_gridService);
    }
    return this._ds_connectors_grid;
  }
  private _ds_get_connectors_name_dd: ProgrammableLogicController_ds_get_connectors_name_ddService;
  public get ds_get_connectors_name_dd(): ProgrammableLogicController_ds_get_connectors_name_ddService {
    if(!this._ds_get_connectors_name_dd) {
      this._ds_get_connectors_name_dd = this.injector.get(ProgrammableLogicController_ds_get_connectors_name_ddService);
    }
    return this._ds_get_connectors_name_dd;
  }
  private _ds_get_containers_ready_for_plc: ProgrammableLogicController_ds_get_containers_ready_for_plcService;
  public get ds_get_containers_ready_for_plc(): ProgrammableLogicController_ds_get_containers_ready_for_plcService {
    if(!this._ds_get_containers_ready_for_plc) {
      this._ds_get_containers_ready_for_plc = this.injector.get(ProgrammableLogicController_ds_get_containers_ready_for_plcService);
    }
    return this._ds_get_containers_ready_for_plc;
  }
  private _ds_get_orderclasses_by_id: ProgrammableLogicController_ds_get_orderclasses_by_idService;
  public get ds_get_orderclasses_by_id(): ProgrammableLogicController_ds_get_orderclasses_by_idService {
    if(!this._ds_get_orderclasses_by_id) {
      this._ds_get_orderclasses_by_id = this.injector.get(ProgrammableLogicController_ds_get_orderclasses_by_idService);
    }
    return this._ds_get_orderclasses_by_id;
  }
  private _ds_get_shipping_containers_contents: ProgrammableLogicController_ds_get_shipping_containers_contentsService;
  public get ds_get_shipping_containers_contents(): ProgrammableLogicController_ds_get_shipping_containers_contentsService {
    if(!this._ds_get_shipping_containers_contents) {
      this._ds_get_shipping_containers_contents = this.injector.get(ProgrammableLogicController_ds_get_shipping_containers_contentsService);
    }
    return this._ds_get_shipping_containers_contents;
  }
  private _ds_get_tote_groupings: ProgrammableLogicController_ds_get_tote_groupingsService;
  public get ds_get_tote_groupings(): ProgrammableLogicController_ds_get_tote_groupingsService {
    if(!this._ds_get_tote_groupings) {
      this._ds_get_tote_groupings = this.injector.get(ProgrammableLogicController_ds_get_tote_groupingsService);
    }
    return this._ds_get_tote_groupings;
  }
  private _ds_get_zone_by_child_location_name: ProgrammableLogicController_ds_get_zone_by_child_location_nameService;
  public get ds_get_zone_by_child_location_name(): ProgrammableLogicController_ds_get_zone_by_child_location_nameService {
    if(!this._ds_get_zone_by_child_location_name) {
      this._ds_get_zone_by_child_location_name = this.injector.get(ProgrammableLogicController_ds_get_zone_by_child_location_nameService);
    }
    return this._ds_get_zone_by_child_location_name;
  }
  private _ds_location_zones: ProgrammableLogicController_ds_location_zonesService;
  public get ds_location_zones(): ProgrammableLogicController_ds_location_zonesService {
    if(!this._ds_location_zones) {
      this._ds_location_zones = this.injector.get(ProgrammableLogicController_ds_location_zonesService);
    }
    return this._ds_location_zones;
  }
  private _ds_orderclasses_dd: ProgrammableLogicController_ds_orderclasses_ddService;
  public get ds_orderclasses_dd(): ProgrammableLogicController_ds_orderclasses_ddService {
    if(!this._ds_orderclasses_dd) {
      this._ds_orderclasses_dd = this.injector.get(ProgrammableLogicController_ds_orderclasses_ddService);
    }
    return this._ds_orderclasses_dd;
  }
  private _ds_projectName_by_id: ProgrammableLogicController_ds_projectName_by_idService;
  public get ds_projectName_by_id(): ProgrammableLogicController_ds_projectName_by_idService {
    if(!this._ds_projectName_by_id) {
      this._ds_projectName_by_id = this.injector.get(ProgrammableLogicController_ds_projectName_by_idService);
    }
    return this._ds_projectName_by_id;
  }
  private _ds_projects_dd: ProgrammableLogicController_ds_projects_ddService;
  public get ds_projects_dd(): ProgrammableLogicController_ds_projects_ddService {
    if(!this._ds_projects_dd) {
      this._ds_projects_dd = this.injector.get(ProgrammableLogicController_ds_projects_ddService);
    }
    return this._ds_projects_dd;
  }
  private _ds_warehouses_dd: ProgrammableLogicController_ds_warehouses_ddService;
  public get ds_warehouses_dd(): ProgrammableLogicController_ds_warehouses_ddService {
    if(!this._ds_warehouses_dd) {
      this._ds_warehouses_dd = this.injector.get(ProgrammableLogicController_ds_warehouses_ddService);
    }
    return this._ds_warehouses_dd;
  }
  private _tote_checking: ProgrammableLogicController_tote_checkingService;
  public get tote_checking(): ProgrammableLogicController_tote_checkingService {
    if(!this._tote_checking) {
      this._tote_checking = this.injector.get(ProgrammableLogicController_tote_checkingService);
    }
    return this._tote_checking;
  }
}

